import request from '@/helper/superagent-protected'
import store from '@/store'

class ParametersService {
  public async getParameters(): Promise<void> {
    try {
      const response = await request.get('/config.json')
      store.dispatch('setParameters', response.body)
    } catch (error) {
      console.error('An error occured while configuration file fetch.')
    }
  }
  public existParameters(): boolean {
    return store.getters.existParameters
  }
}

export default new ParametersService()
